// extracted by mini-css-extract-plugin
export default {"group":"ToggleButtonDefault_group__imCr4"};